import { format } from 'date-fns'
import round from 'lodash/round'

export const formatPercentage = (num: number | null, precision?: number) => {
  if (num === null) {
    return 'N/A'
  }

  return `${round(num * 100, precision)}%`
}

export const formatNumberMillions = (
  num?: number,
  short: boolean = false,
  precision: number = 2,
  locale: string = 'en-US',
) => {
  if (!num) {
    num = 0
  }

  if (!short) {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num)
  }

  if (num >= 1000000) {
    return `${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(num / 1000000)}M`
  }
  if (num >= 10000) {
    return `${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num / 1000)}k`
  }
  if (num >= 1000) {
    return `${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }).format(num / 1000)}k`
  }
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  }).format(num)
}

export const formatDate = (date: Date | string, fmt?: string) =>
  format(new Date(date), fmt || 'd MMM yyyy')

export const formatDateTime = (date: Date | string, fmt?: string) =>
  format(new Date(date), fmt || 'd MMM yyyy HH:mm')
